/* --------------------------------------------------------------------------
 *  venta.js – Versión actualizada (prefijos fijos)
 *
 *  Documentos y prefijos:
 *    • REM → prefijo 999          (siempre)
 *    • FAA → prefijo 141          (cliente con factura)
 *    • FAB → prefijo 400          (venta mostrador / sin cliente)
 *
 *  Reglas de emisión:
 *    1. cliente.emiteRemito === true           →  sólo REM
 *    2. cliente.emiteFacturayRemito === true   →  REM + FAA/FAB
 *    3. ambos en false/undefined               →  sólo FAA/FAB
 * ------------------------------------------------------------------------*/

const generateResponseFromFacturaInfo = () => {
  const facturaInfo = localStorage.getItem("facturaInfo");

  /* ───────────────────────────────
   * 1. Fallback hardcodeado
   * ─────────────────────────────── */
  if (!facturaInfo) {
    return {
      respuestas: [
        {
          idMovimientoFac: 336965,
          idTipoMovimiento: "FAB",
          cAENumero: null,
          cAEFechaVencimiento: "2025-08-04T09:23:24.251",
          prefijo: 400, // ← FAB ahora 400
          numero: 238,
          detallesMovimiento: {
            neto: 1169.1476,
            iVA: 245.521,
            porcentajeIVA: 0.21,
            iTC: 8.1808,
            iDC: 1.7228,
            percepcionIIBB: 0,
            percepcionIVA: 0,
            otrasPercepciones: 0,
            tasaVial: 0,
            total: 1424.5722,
            detallesArticulos: [
              {
                idMovimientosDetalleFac: 511852,
                precio: 1402,
                cantidad: 1.0161,
                descripcion: "INFINIA DIESEL ",
                descripcionPersonalizada: "",
              },
            ],
          },
        },
      ],
      cuponClover: {
        success: false,
        result: null,
        payment: null,
        signature: null,
        isSale: false,
        isAuth: false,
        isPreAuth: false,
      },
      fidelizacionResponse: null,
    };
  }

  /* ───────────────────────────────
   * 2. Variables básicas
   * ─────────────────────────────── */
  const factura = JSON.parse(facturaInfo);
  const respuestas = [];
  let idMovimiento = 336965; // correlativo interno
  let detalleId = 511852; // correlativo de detalle

  /* ───────────────────────────────
   * 3. Flags de emisión (cliente)
   * ─────────────────────────────── */
  const cliente = factura.cliente || {};

  const emiteSoloRemito = cliente.emiteRemito === true && cliente.emiteFacturayRemito !== true;

  const emiteRemitoYFactura = cliente.emiteFacturayRemito === true;

  const tieneCliente = !!cliente.idCliente;
  const tipoMovimiento = tieneCliente ? "FAA" : "FAB"; // sólo etiqueta

  /* ───────────────────────────────
   * 4. Prefijos fijos y numeraciones
   * ─────────────────────────────── */
  const PREFIJO_REM = 999; // REM
  const PREFIJO_FAA = 141; // FAA
  const PREFIJO_FAB = 400; // FAB

  const getPrefijoFactura = tipo => (tipo === "FAA" ? PREFIJO_FAA : PREFIJO_FAB);

  let numeroREM = 6931; // ejemplo correlativo
  let numeroFactura = emiteRemitoYFactura ? 87 : 238;

  /* ───────────────────────────────
   * 5. Helpers para despachos y artículos
   * ─────────────────────────────── */
  const generarRespuestaDespachos = (tipoMov, prefijo, numero) => {
    if (!factura.despachos || factura.despachos.length === 0) return null;

    const detalles = [];
    let neto = 0,
      iva = 0,
      itc = 0,
      idc = 0,
      total = 0;

    factura.despachos.forEach(d => {
      const precio = d.precio || 0;
      const cantidad = d.litros || 0;
      const importe = precio * cantidad || d.importe || 0;
      
      total += Math.round(importe * 100) / 100;

      const n = importe / 1.21;
      const v = importe - n;
      const t = n * 0.007; // ITC aprox
      const c = n * 0.0015; // IDC aprox

      neto += n;
      iva += v;
      itc += t;
      idc += c;

      detalles.push({
        idMovimientosDetalleFac: detalleId++,
        precio,
        cantidad,
        descripcion: d.producto || "COMBUSTIBLE",
        descripcionPersonalizada: d.descripcionPersonalizada || "",
      });
    });

    return {
      idMovimientoFac: idMovimiento++,
      idTipoMovimiento: tipoMov,
      cAENumero: null,
      cAEFechaVencimiento: "2025-08-04T09:23:24.251",
      prefijo,
      numero,
      detallesMovimiento: {
        neto: Math.round(neto * 100) / 100,
        iVA: Math.round(iva * 100) / 100,
        porcentajeIVA: 0.21,
        iTC: Math.round(itc * 100) / 100,
        iDC: Math.round(idc * 100) / 100,
        percepcionIIBB: 0,
        percepcionIVA: 0,
        otrasPercepciones: 0,
        tasaVial: 0,
        total: Math.round(total * 100) / 100,
        detallesArticulos: detalles,
      },
    };
  };

  const generarRespuestaArticulos = (tipoMov, prefijo, numero) => {
    if (!factura.articulos || factura.articulos.length === 0) return null;

    const detalles = [];
    let neto = 0,
      iva = 0;

    factura.articulos.forEach(a => {
      const precio = a.precioPublico || 0;
      const cantidad = a.cantidadArticulo || 1;
      const importe = a.importe || 0;

      const alic = a.alicuotaIVA || 21;
      const n = importe / (1 + alic / 100);
      const v = importe - n;

      neto += n;
      iva += v;

      detalles.push({
        idMovimientosDetalleFac: detalleId++,
        precio,
        cantidad,
        descripcion: a.descripcion || "ARTICULO",
        descripcionPersonalizada: a.descripcionPersonalizada || "",
      });
    });

    const total = neto + iva;

    return {
      idMovimientoFac: idMovimiento++,
      idTipoMovimiento: tipoMov,
      cAENumero: null,
      cAEFechaVencimiento: "2025-08-04T09:23:24.267",
      prefijo,
      numero,
      detallesMovimiento: {
        neto: Math.round(neto * 100) / 100,
        iVA: Math.round(iva * 100) / 100,
        porcentajeIVA: 0.21,
        iTC: 0,
        iDC: 0,
        percepcionIIBB: 0,
        percepcionIVA: 0,
        otrasPercepciones: 0,
        tasaVial: 0,
        total: Math.round(total * 100) / 100,
        detallesArticulos: detalles,
      },
    };
  };

  /* ───────────────────────────────
   * 6. Generación de documentos
   * ─────────────────────────────── */

  /* a) REM (si corresponde) */
  if (emiteSoloRemito || emiteRemitoYFactura) {
    const remDesp = generarRespuestaDespachos("REM", PREFIJO_REM, numeroREM++);
    if (remDesp) respuestas.push(remDesp);

    const remArt = generarRespuestaArticulos("REM", PREFIJO_REM, numeroREM++);
    if (remArt) respuestas.push(remArt);
  }

  /* b) FAA/FAB (salvo que sea sólo REM) */
  if (!emiteSoloRemito) {
    const prefFac = getPrefijoFactura(tipoMovimiento); // 141 ó 400

    const facDesp = generarRespuestaDespachos(tipoMovimiento, prefFac, numeroFactura++);
    if (facDesp) respuestas.push(facDesp);

    const facArt = generarRespuestaArticulos(tipoMovimiento, prefFac, numeroFactura++);
    if (facArt) respuestas.push(facArt);
  }

  /* ───────────────────────────────
   * 7. Devuelve la respuesta final
   * ─────────────────────────────── */
  return {
    respuestas,
    cuponClover: {
      success: false,
      result: null,
      payment: null,
      signature: null,
      isSale: false,
      isAuth: false,
      isPreAuth: false,
    },
    fidelizacionResponse: null,
  };
};

/* --------------------------------------------------------------------------
 *  Servicio postVenta
 * ------------------------------------------------------------------------*/
const postVenta = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const facturaJson = localStorage.getItem("facturaJson");
  const cuponClover = localStorage.getItem("CuponClover");

  const userData = {
    nic: formattedNic,
    token,
    venta: facturaJson,
    cuponClover,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };

  try {
    const responseData = generateResponseFromFacturaInfo();

    localStorage.setItem("CAE", responseData.respuestas[0].cAENumero);
    localStorage.setItem("prefijo", responseData.respuestas[0].prefijo);
    localStorage.setItem("numero", responseData.respuestas[0].numero);

    return { data: responseData };
  } catch (error) {
    console.log(error.response?.data?.message || error.message);
    localStorage.setItem("errorMensaje", error.response?.data?.exceptionMessage || error.message);
    localStorage.setItem("reintentos", 1);
    return null;
  }
};

const venta = { postVenta };
export default venta;
